import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'
import { UpdateAdvertRequestDTO } from '@core/api/dtos/request/advert/update'

export const advertService = {
	uploadAdvert(
		data: FormData,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.post('/my/adverts', data, {
			...config,
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
	},

	/**
	 * List/paginate adverts for the current account.
	 */
	paginateAdverts(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/my/adverts', config)
	},

	/**
	 * Patch an existing advert's metadata (name, description, start/end dates).
	 */
	patchAdvert(
		advertId: number,
		data: UpdateAdvertRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.patch(`/my/adverts/${advertId}`, data, config)
	},
}
